import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducers';
import { getWorkspaceSettings } from 'app/internal/workspace/workspace-store/workspace.selectors';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CLUB_SUBSCRIPTION_PLAN_ID } from '../../constants/club-subscription-plan-id';

/** Placeholder for WEB-3355 (Members list). */
@Component({
  selector: 'sp-membership-members-placeholder',
  templateUrl: './membership-members-placeholder.component.html',
  styleUrls: ['./membership-members-placeholder.component.scss'],
  standalone: false,
})
export class MembershipMembersPlaceholderComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.store
      .select(getWorkspaceSettings)
      .pipe(
        filter(ws => ws != null),
        takeUntil(this.destroy$),
      )
      .subscribe(ws => {
        const planId = ws.subscriptionPlanId != null ? ws.subscriptionPlanId : 1;
        if (planId !== CLUB_SUBSCRIPTION_PLAN_ID) {
          void this.router.navigate(['/useraccount/properties/dashboard']);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
